export default __webpack_public_path__ + "static/Kenya-child-donation-5e305265666556b2b0a5a75d93cb2e46.png";